<template lang="pug">
.container.grid-lg.my-2
  load-manager(:status="status")
    div(v-if="doc")
      .card
        .card-header
          .card-title.center
            div {{ doc.modelo.titulo }} Nº
              b.lg {{ doc.numero }}/{{ doc.ano }}
            .abbr {{ doc.modelo.descricao }}
        .card-body
          .columns
            item-col.py-2.col-4.col-xs-6(
              label="doc.created_at",
              :value="doc.created_at | date"
            )
            item-col.py-2.col-4.col-xs-6(
              label="doc.ciencia_em",
              :value="doc.ciencia_em | date"
            )
            item-col.py-2.col-4.col-xs-6(
              label="doc.autuado_em",
              :value="doc.autuado_em | date"
            )
            item-col.py-2.col-4.col-xs-6(
              label="doc.situacao",
              :value="doc.situacao ? doc.situacao.descricao : ''"
            )
            item-col.py-2.col-4.col-xs-6(
              label="doc.fiscal",
              :value="doc.fiscal ? doc.fiscal.nome : ''"
            )
            item-col.py-2.col-4.col-xs-6(
              label="contribuinte.cpf_cnpj",
              :value="docCpfCnpj | cpfCnpj"
            )
            item-col.py-2.col-12(
              label="contribuinte.razao_social",
              :value="docRazaoSocial"
            )
      .card
        .card-header
          .card-title.text-primary
            h4 Implantar documento
          .card-body
            fieldset(:disabled="loading")
              form(@submit.prevent="implantar")
                .columns
                  .column.col-12
                    form-group(label="PAF", :validation="$v.form.paf")
                      input.form-input(v-model="$v.form.paf.$model")
                  .column.col-12
                    form-group(
                      label="Observação do lançamento",
                      :validation="$v.form.obs"
                    )
                      input.form-input(
                        type="text",
                        v-model="$v.form.obs.$model",
                        placeholder="Observação do lançamento"
                      )
                  .column.col-12
                    .form-group
                      label.form-switch
                        input(
                          type="checkbox",
                          v-model="$v.form.revisado.$model"
                        )
                        .form-icon 
                        | Revisado
                .columns(v-if="$v.form.revisado.$model")
                  .column.col-12
                    form-group(
                      label="Protocolo",
                      :validation="$v.form.protocolo"
                    )
                      input.form-input(
                        type="tel",
                        v-model="$v.form.protocolo.$model"
                      )
                  .column.col-12
                    form-group(
                      label="Observação da revisão",
                      :validation="$v.form.revisao_obs"
                    )
                      input.form-input(
                        type="text",
                        v-model="$v.form.revisao_obs.$model",
                        placeholder="Observação da revisão"
                      )
                .pt-2.text-right
                  button.btn.btn-primary(
                    type="submit",
                    :class="{ loading: loading }",
                    :disabled="$v.$invalid || loading"
                  ) Implantar
      .divider
      .text-right
        slot(name="actions")
        btn-logs(
          entityName="Doc",
          :entityId="doc.id",
          v-acl:allowed.admin.logs.index
        )
        a.btn.btn-link(:href="doc.url", target="_blank")
          btn-content(name="print")
        a.btn.btn-link(:href="`${doc.url}.pdf`", target="_blank")
          btn-content(label="PDF", icon="fa fa-file-pdf-o")
</template>

<script>
import { deepKey } from "paliari-js-utils"
import toastErrors from "@/lib/errors/toastErrors"
import DocImplantacao from "@/models/DocImplantacao"

export default {
  vuex: {
    "fiscalizacao/docImplantacoes": {
      state: ["current", "status"],
      actions: ["fetchImplantar", "fetchOne"],
      getters: ["loading"],
    },
  },

  validations: {
    form: DocImplantacao.validations,
  },

  data() {
    return { form: new DocImplantacao({ id: Number(this.$route.params.id) }) }
  },

  computed: {
    doc() {
      return this.current
    },
    docCpfCnpj() {
      return deepKey(this.doc, "cadastro.contribuinte.cpf_cnpj")
    },
    docRazaoSocial() {
      return deepKey(this.doc, "cadastro.contribuinte.razao_social")
    },
    docId() {
      return Number(this.$route.params.id)
    },
  },

  methods: {
    implantar() {
      const options = { cancelLabel: "Não", title: "Confirmação" }
      this.$dialogs.confirm("Tem certeza?", options).then((res) => {
        if (res.ok) {
          this.fetchImplantar({ id: this.docId, implantacao: this.form })
            .then(() => {
              this.$toaster.success("Implantado com sucesso")
              this.$router.go(-1)
            })
            .catch((e) => {
              toastErrors(e)
              this.fetchOne(this.docId)
            })
        }
      })
    },
  },

  async created() {
    if (!this.current || this.current.id !== this.docId) {
      try {
        await this.fetchOne(this.docId)
      } catch (e) {
        toastErrors(e)
      }
    }
  },
}
</script>
